module.exports = __webpack_public_path__ + "img/error.e2f75131.png";